var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 27,
    viewBox: "0 0 33 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6001 3.60943C31.4228 4.1321 30.1574 4.4841 28.8294 4.64276C30.1854 3.83076 31.2268 2.5441 31.7161 1.01076C30.4481 1.76276 29.0428 2.30943 27.5468 2.60409C26.3508 1.32809 24.6428 0.530762 22.7548 0.530762C18.5161 0.530762 15.4014 4.48543 16.3588 8.59076C10.9041 8.31743 6.06676 5.70409 2.8281 1.7321C1.1081 4.68276 1.9361 8.54276 4.85876 10.4974C3.7841 10.4628 2.77076 10.1681 1.88676 9.6761C1.81476 12.7174 3.99476 15.5628 7.1521 16.1961C6.2281 16.4468 5.2161 16.5054 4.18676 16.3081C5.02143 18.9161 7.44543 20.8134 10.3201 20.8668C7.5601 23.0308 4.08276 23.9974 0.600098 23.5868C3.50543 25.4494 6.95743 26.5361 10.6641 26.5361C22.8534 26.5361 29.7401 16.2414 29.3241 7.0081C30.6068 6.08143 31.7201 4.92543 32.6001 3.60943Z",
    fill: "#1B1D23"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.df2f24fcdd44bb2c4cfd5f9417477422.svg";
export { ForwardRef as ReactComponent };